import type { Faq } from '../types/content'

export const projectTypes: string[] = [
  'New website',
  'Website redesign',
  'Brand and identity',
  'E-commerce store',
  'Product or app design',
  'Ongoing design support',
  'Something else',
]

export const budgetRanges: string[] = [
  'Under ₹ 15,000',
  '₹ 15,000 – ₹ 25,000',
  '₹ 25,000 – ₹ 50,000',
  '₹ 50,000+',
  'Not sure yet',
]

export const timelines: string[] = [
  'As soon as possible',
  'Within 1 month',
  '1–3 months',
  '3+ months',
  'Just exploring',
]

export const nextSteps: { title: string; duration: string; description: string }[] = [
  {
    title: 'We reply within one business day',
    duration: 'Day 1',
    description:
      'A real answer from the person who would do the work — either questions, or a time to talk. If we are not the right studio for it, you will hear that instead.',
  },
  {
    title: 'A 30-minute call',
    duration: 'Day 2–3',
    description:
      'You talk about the business and the deadline, we ask questions and tell you what we would do. No deck, no pitch, no second call with a salesperson.',
  },
  {
    title: 'A fixed proposal',
    duration: 'Within a week',
    description:
      'Scope, fixed price and the exact launch date on one page. If you sign, we book the slot and the 50% deposit starts the work.',
  },
]

export const contactFaqs: Faq[] = [
  {
    question: 'Why do you ask for a budget range?',
    answer:
      'So the first call is useful rather than exploratory. A range tells us whether the project is a two-week landing page or a five-week build, and we can come to the call with a real recommendation instead of questions. "Not sure yet" is a perfectly good answer.',
  },
  {
    question: 'What if I do not have content or a brief yet?',
    answer:
      'That is a normal starting point. A paragraph about what the company sells and who buys it is enough. Writing the structure and the copy is part of the design work, and we will tell you on the call whether you need that.',
  },
  {
    question: 'How soon could we start?',
    answer:
      'We run one project at a time, so start dates depend on the schedule. We are currently taking on new projects. If you have a hard deadline, say so in the message and we will tell you immediately whether it is possible.',
  },
  {
    question: 'Do you work remotely?',
    answer:
      'Yes. The studio works remotely with clients anywhere in India. We keep 10:00–19:00 IST hours, reviews happen on a call with the work in front of you, and anything you miss arrives as a recorded walkthrough.',
  },
]
